import { ChangeDetectionStrategy, Component, computed, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { kutukGeo } from '@/src/app/shared/utils/param-deger.utils';

@Component({
  selector: 'kutuk-stok-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ke">
      <div class="ke-row">
        <div class="ke-alan" style="flex:1">
          <label class="ke-etiket">İsim</label>
          <input nz-input nzSize="small" [ngModel]="p()?.isim || ''" (ngModelChange)="guncelle('isim', $event)" placeholder="Ör: 350lik Kütük"/>
        </div>
        <div class="ke-alan" style="flex:0 0 100px">
          <label class="ke-etiket">Birim</label>
          <input nz-input nzSize="small" [ngModel]="p()?.birim || 'adet'" (ngModelChange)="guncelle('birim', $event)" placeholder="adet"/>
        </div>
      </div>

      <div class="ke-gorsel">
        <svg [attr.viewBox]="geo().vb" preserveAspectRatio="xMidYMid meet" class="ke-svg">
          <defs>
            <linearGradient id="ksUst" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#fbbf24"/><stop offset="100%" stop-color="#f59e0b"/></linearGradient>
            <linearGradient id="ksOn" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#d97706"/><stop offset="100%" stop-color="#b45309"/></linearGradient>
            <linearGradient id="ksSag" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#b45309"/><stop offset="100%" stop-color="#92400e"/></linearGradient>
            <marker id="ksB" viewBox="0 0 8 8" refX="4" refY="4" markerWidth="4" markerHeight="4" orient="auto-start-reverse"><path d="M1,1 L7,4 L1,7Z" fill="#3b82f6"/></marker>
            <marker id="ksG" viewBox="0 0 8 8" refX="4" refY="4" markerWidth="4" markerHeight="4" orient="auto-start-reverse"><path d="M1,1 L7,4 L1,7Z" fill="#22c55e"/></marker>
            <marker id="ksR" viewBox="0 0 8 8" refX="4" refY="4" markerWidth="4" markerHeight="4" orient="auto-start-reverse"><path d="M1,1 L7,4 L1,7Z" fill="#ef4444"/></marker>
            <filter id="ksSh"><feDropShadow dx="1" dy="2" stdDeviation="2" flood-color="#000" flood-opacity=".12"/></filter>
          </defs>
          <pattern id="ksGrid" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M 20 0 L 0 0 0 20" fill="none" stroke="var(--py-kenarlik,#e5e7eb)" stroke-width=".3" opacity=".5"/>
          </pattern>
          <rect width="100%" height="100%" fill="url(#ksGrid)"/>
          <g filter="url(#ksSh)">
            <polygon [attr.points]="geo().on" fill="url(#ksOn)"/>
            <polygon [attr.points]="geo().sag" fill="url(#ksSag)"/>
            <polygon [attr.points]="geo().ust" fill="url(#ksUst)"/>
          </g>
          <polygon [attr.points]="geo().on" fill="none" stroke="#92400e" stroke-width="1" stroke-linejoin="round"/>
          <polygon [attr.points]="geo().sag" fill="none" stroke="#78350f" stroke-width="1" stroke-linejoin="round"/>
          <polygon [attr.points]="geo().ust" fill="none" stroke="#a16207" stroke-width="1" stroke-linejoin="round"/>
          <g [attr.transform]="'translate(0,' + (geo().by + 18) + ')'">
            <line [attr.x1]="geo().bx" y1="0" [attr.x2]="geo().bx + geo().w" y2="0" stroke="#3b82f6" stroke-width="1.5" marker-start="url(#ksB)" marker-end="url(#ksB)"/>
            <text [attr.x]="geo().bx + geo().w/2" y="14" text-anchor="middle" fill="#3b82f6" font-size="9" font-weight="700" font-family="monospace">{{ geo().enD }}</text>
          </g>
          <g [attr.transform]="'translate(' + (geo().bx - 18) + ',0)'">
            <line x1="0" [attr.y1]="geo().by" x2="0" [attr.y2]="geo().by - geo().h" stroke="#ef4444" stroke-width="1.5" marker-start="url(#ksR)" marker-end="url(#ksR)"/>
            <text x="-4" [attr.y]="geo().by - geo().h/2 + 4" text-anchor="middle" fill="#ef4444" font-size="9" font-weight="700" font-family="monospace">{{ geo().yukD }}</text>
          </g>
          <line [attr.x1]="geo().bx + geo().w + 18" [attr.y1]="geo().by" [attr.x2]="geo().bx + geo().w + geo().dh + 18" [attr.y2]="geo().by - geo().dh" stroke="#22c55e" stroke-width="1.5" marker-start="url(#ksG)" marker-end="url(#ksG)"/>
          <text [attr.x]="geo().bx + geo().w + geo().dh*.5 + 30" [attr.y]="geo().by - geo().dh*.5 + 4" text-anchor="middle" fill="#22c55e" font-size="9" font-weight="700" font-family="monospace">{{ geo().boyD }}</text>
        </svg>
      </div>

      <div class="ke-row">
        <div class="ke-alan">
          <label class="ke-etiket">En (mm)</label>
          <input nz-input nzSize="small" type="number" [ngModel]="p()?.en" (ngModelChange)="guncelle('en', $event)" placeholder="En"/>
        </div>
        <div class="ke-alan">
          <label class="ke-etiket">Boy (mm)</label>
          <input nz-input nzSize="small" type="number" [ngModel]="p()?.boy" (ngModelChange)="guncelle('boy', $event)" placeholder="Boy"/>
        </div>
        <div class="ke-alan">
          <label class="ke-etiket">Yükseklik (mm)</label>
          <input nz-input nzSize="small" type="number" [ngModel]="p()?.yukseklik" (ngModelChange)="guncelle('yukseklik', $event)" placeholder="Yükseklik"/>
        </div>
      </div>

      <div class="ke-row">
        <div class="ke-alan">
          <label class="ke-etiket">Uyarı Limiti</label>
          <input nz-input nzSize="small" type="number" [ngModel]="p()?.uyariLimit" (ngModelChange)="guncelle('uyariLimit', $event)" placeholder="Ör: 30"/>
          <span class="ke-aciklama">Bu miktarın altına inince "Uyarı" rozeti gösterilir</span>
        </div>
        <div class="ke-alan">
          <label class="ke-etiket">Kritik Limit</label>
          <input nz-input nzSize="small" type="number" [ngModel]="p()?.kritikLimit" (ngModelChange)="guncelle('kritikLimit', $event)" placeholder="Ör: 15"/>
          <span class="ke-aciklama">Bu miktarın altına inince "Kritik" rozeti gösterilir</span>
        </div>
      </div>

      <div class="ke-row">
        <div class="ke-alan" style="flex:1">
          <label class="ke-etiket">Notlar</label>
          <input nz-input nzSize="small" [ngModel]="p()?.notlar || ''" (ngModelChange)="guncelle('notlar', $event)" placeholder="Kısa not yazın..."/>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .ke { display:flex; flex-direction:column; gap:8px; }
    .ke-gorsel { display:flex; justify-content:center; overflow:hidden; border-radius:8px; border:1px solid var(--py-kenarlik,#f0f0f0); background:var(--py-arkaplan,#fff); }
    .ke-svg { display:block; width:100%; height:140px; }
    .ke-row { display:flex; gap:10px; }
    .ke-alan { display:flex; flex-direction:column; gap:2px; flex:1; padding:4px 0; }
    .ke-etiket { font-weight:500; font-size:12px; color:var(--py-metin-ucuncul, rgba(0,0,0,.45)); letter-spacing:-0.1px; }
    .ke-aciklama { font-size:11px; color:var(--py-metin-devre-disi, rgba(0,0,0,.25)); margin-top:1px; }
  `],
})
export class KutukStokEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
    this._geoTetik.set(Date.now());
  }

  _geoTetik = signal(0);
  geo = computed(() => {
    this._geoTetik();
    const ek = this.parametreler()?.ek || {};
    return kutukGeo(+(ek?.en || 0), +(ek?.boy || 0), +(ek?.yukseklik || 0));
  });
}
